import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import LeagueCard from '@/components/leaderboard/LeagueCard';

export interface FriendsTabProps {
  onCreateLeague: () => void;
  onViewLeagueLeaderboard: (leagueName: string, leagueColor: 'orange' | 'blue') => void;
}

const FriendsTab: React.FC<FriendsTabProps> = ({ onCreateLeague, onViewLeagueLeaderboard }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <LeagueCard
          name="DA BOYZ ARE BACK"
          color="orange"
          onViewLeaderboard={() => onViewLeagueLeaderboard('DA BOYZ ARE BACK', 'orange')}
          onSettings={() => console.log('Orange settings')}
        />

        <LeagueCard
          name="WORK FRIENDS"
          color="blue"
          onViewLeaderboard={() => onViewLeagueLeaderboard('WORK FRIENDS', 'blue')}
          onSettings={() => console.log('Blue settings')}
        />
      </div>

      <div className="bg-surface rounded-xl p-6 text-center">
        <div className="flex justify-center items-center gap-4 mb-4">
          <span className="text-2xl">😄</span>
          <h3 className="text-foreground font-bold text-xl">{t('friends.challengeTitle')}</h3>
          <span className="text-2xl">😎</span>
        </div>

        <p className="text-muted-foreground mb-6">{t('friends.challengeSubtitle')}</p>

        <div className="space-y-3">
          <div className="flex gap-3">
            <Button variant="secondary" className="flex-1">
              {t('friends.joinLeague')}
            </Button>
            <Button variant="default" onClick={onCreateLeague} className="flex-1">
              {t('friends.createLeague')}
            </Button>
          </div>

          <p className="text-muted-foreground text-sm">{t('friends.inviteHint')}</p>
        </div>
      </div>
    </div>
  );
};

export default FriendsTab;
